export default "__VITE_ASSET__21274246__"